import * as api from '../connectivity/api.memberships';
import { call, put } from 'redux-saga/effects';
import {takeEvery, takeLatest} from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {browserHistory} from "react-router";
import _ from "lodash";
import {spaceToUnderscore} from "../helpers/helpers";


export function* doRequestDropboxUserMemberships(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'memberships.doRequestDropboxUserMemberships'
            }
        });

        const { dropboxId, userId } = action.payload,
            memberships = yield call(api.fetchDropboxUserMemberships, dropboxId, userId)
        ;

        yield put({
            type: types.DROPBOX__USER__MEMBERSHIPS__REQUESTED__SUCCEEDED,
            payload: {
                memberships,
                dropbox: dropboxId,
                user: userId
            },
        });
    } catch (e) {
        yield put({
            type: types.DROPBOX__USER__MEMBERSHIPS__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'memberships.doRequestDropboxUserMemberships'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxUserMembershipsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'memberships.doRequestDropboxUserMemberships'
        }
    });
}

export function* doRequestDropboxUserMembershipsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'memberships.doRequestDropboxUserMemberships'
        }
    });
}

export function* doRequestAssignmentMemberships(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'memberships.doRequestAssignmentMemberships'
            }
        });

        const { assignmentId } = action.payload,
            memberships = yield call(api.fetchAssignmentMemberships, assignmentId)
        ;

        yield put({
            type: types.ASSIGNMENT__MEMBERSHIPS__REQUESTED__SUCCEEDED,
            payload: {
                memberships,
                assignment: assignmentId,
            }
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__MEMBERSHIPS__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'memberships.doRequestAssignmentMemberships'
        }
    });

    yield put(hideLoading());
}

export function* doRequestAssignmentMembershipsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'memberships.doRequestAssignmentMemberships'
        }
    });
}

export function* doRequestAssignmentMembershipsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'memberships.doRequestAssignmentMemberships'
        }
    });
}

export function* doRequestSubmissionMemberships(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'memberships.doRequestSubmissionMemberships'
            }
        });

        const { submissionId } = action.payload,
            memberships = submissionId === "-1"
            ?
                {}
            :
                yield call(api.fetchSubmissionMemberships, submissionId)
        ;

        yield put({
            type: types.SUBMISSION__MEMBERSHIPS__REQUESTED__SUCCEEDED,
            payload: {
                memberships,
                submission: submissionId,
            }
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__MEMBERSHIPS__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'memberships.doRequestSubmissionMemberships'
        }
    });

    yield put(hideLoading());
}

export function* doRequestSubmissionMembershipsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'memberships.doRequestSubmissionMemberships'
        }
    });
}

export function* doRequestSubmissionMembershipsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'memberships.doRequestSubmissionMemberships'
        }
    });
}

export function* doRequestDeleteSubmissionMembership(action) {
    yield put(showLoading());

    try{
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'memberships.doRequestDeleteSubmissionMembership'
            }
        });

        const { payload } = action,
            { assignment, membership } = payload
        ;

        yield call(api.deleteSubmissionMembership, membership.id);

        yield put({
            type: types.SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__SUCCEEDED,
            payload: { assignment, membership },
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'memberships.doRequestDeleteSubmissionMembership'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDeleteSubmissionMembershipSucceeded(action) {
    const { assignment } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Submission Membership deleted successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'memberships.doRequestDeleteSubmissionMembership'
        }
    });

    browserHistory.push(`/${assignment.dropbox.name}/${spaceToUnderscore(assignment.name)}`);
}

export function* doRequestDeleteSubmissionMembershipFailed(action) {
    const { message } = action.message;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error: failed to delete submission membership. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'memberships.doRequestDeleteSubmissionMembership'
        }
    });
}

export function* doRequestDeclineSubmissionMembership(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'submissions.doRequestDeclineSubmissionMembership'
        }
    });

    const { payload } = action,
        { assignment, membership } = payload
    ;

    try{
        yield call(api.deleteSubmissionMembership, membership.id);

        yield put({
            type: types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED,
            payload: { assignment, membership }
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'submissions.doRequestDeclineSubmissionMembership'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDeclineSubmissionMembershipSucceeded(action) {
    const { assignment } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Group membership declined successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestDeclineSubmissionMembership'
        }
    });

    browserHistory.push(`/${assignment.dropbox.name}/${spaceToUnderscore(assignment.name)}`);
}

export function* doRequestDeclineSubmissionMembershipFailed(action) {
    const { data } = action;

    let { message } = action;

    if (data && data.errors &&
        _.some(
            data.errors,
            (error) => {
                return error.indexOf('has been updated') > -1;
            }
        )
    ) {
        message = 'Submission has been updated.  Please Refresh.';
    }

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error declining group membership. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestDeclineSubmissionMembership'
        }
    });
}

export function* watchRequestDropboxUserMemberships() {
    yield* takeLatest(types.DROPBOX__USER__MEMBERSHIPS__REQUESTED, doRequestDropboxUserMemberships);
}

export function* watchRequestDropboxUserMembershipsSucceeded() {
    yield* takeLatest(types.DROPBOX__USER__MEMBERSHIPS__REQUESTED__SUCCEEDED, doRequestDropboxUserMembershipsSucceeded);
}


export function* watchRequestDropboxUserMembershipsFailed() {
    yield* takeLatest(types.DROPBOX__USER__MEMBERSHIPS__REQUESTED__FAILED, doRequestDropboxUserMembershipsFailed);
}

export function* watchRequestAssignmentMemberships() {
    yield* takeLatest(types.ASSIGNMENT__MEMBERSHIPS__REQUESTED, doRequestAssignmentMemberships);
}

export function* watchRequestAssignmentMembershipsSucceeded() {
    yield* takeLatest(types.ASSIGNMENT__MEMBERSHIPS__REQUESTED__SUCCEEDED, doRequestAssignmentMembershipsSucceeded);
}

export function* watchRequestAssignmentMembershipsFailed() {
    yield* takeLatest(types.ASSIGNMENT__MEMBERSHIPS__REQUESTED__FAILED, doRequestAssignmentMembershipsFailed);
}

export function* watchRequestSubmissionMemberships() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIPS__REQUESTED, doRequestSubmissionMemberships);
}

export function* watchRequestSubmissionMembershipsSucceeded() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIPS__REQUESTED__SUCCEEDED, doRequestSubmissionMembershipsSucceeded);
}

export function* watchRequestSubmissionMembershipsFailed() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIPS__REQUESTED__FAILED, doRequestSubmissionMembershipsFailed);
}

export function* watchRequestDeleteSubmissionMembership() {
    yield* takeEvery(types.SUBMISSION__MEMBERSHIP__DELETE__REQUESTED, doRequestDeleteSubmissionMembership);
}

export function* watchRequestDeleteSubmissionMembershipSucceeded() {
    yield* takeEvery(types.SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__SUCCEEDED, doRequestDeleteSubmissionMembershipSucceeded);
}

export function* watchRequestDeleteSubmissionMembershipFailed() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIP__DELETE__REQUESTED__FAILED, doRequestDeleteSubmissionMembershipFailed);
}

export function* watchRequestDeclineSubmissionMembership() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED, doRequestDeclineSubmissionMembership);
}

export function* watchRequestDeclineSubmissionMembershipSucceeded() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED, doRequestDeclineSubmissionMembershipSucceeded);
}

export function* watchRequestDeclineSubmissionMembershipFailed() {
    yield* takeLatest(types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__FAILED, doRequestDeclineSubmissionMembershipFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/memberships.saga.js
 **/